import { ArrowRight as ArrowRight_kojaro } from './ArrowRight.kojaro';
import { ArrowRight as ArrowRight_phosphor } from './ArrowRight.phosphor';
import { ArrowRight as ArrowRight_zoomg } from './ArrowRight.zoomg';
import { ArrowRight as ArrowRight_zoomit } from './ArrowRight.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return ArrowRight_kojaro;

    case 'zoomg':
      return ArrowRight_zoomg;

    case 'phosphor':
      return ArrowRight_phosphor;

    default:
      return ArrowRight_zoomit;
  }
};

export const ArrowRight = IconRenderer();
